import React, { memo } from "react";
import { AppButton } from "components";
import { useLevelButton } from "./index.hooks";
import { ILevel, LevelDifficulties, LevelTypes } from "models";
import { Stack, SvgIcon, Typography } from "@mui/material";
import { ReactComponent as RoadSignIcon } from "assets/road-sign.svg";
import { ReactComponent as BridgeIcon } from "assets/bridge.svg";
import { ReactComponent as StationIcon } from "assets/station.svg";

type LevelButtonProps = {
  level: ILevel;
};

export const LevelButton = memo(({ level, ...props }: LevelButtonProps) => {
  const { onClick, isTooNarrow } = useLevelButton(level);

  const { difficulty, type, name } = level;

  const renderSubTitle = () => {
    switch (difficulty) {
      case LevelDifficulties.easy:
        return "livello facile";
      case LevelDifficulties.medium:
        return "livello medio";
      case LevelDifficulties.hard:
        return "livello difficile";
      default:
        return "";
    }
  };

  const renderIcon = () => {
    switch (type) {
      case LevelTypes.station:
        return StationIcon;
      case LevelTypes.roadSign:
        return RoadSignIcon;
      case LevelTypes.bridge:
        return BridgeIcon;
      default:
        return BridgeIcon;
    }
  };

  const getColor = () => {
    switch (difficulty) {
      case LevelDifficulties.easy:
        return "tertiary";
      case LevelDifficulties.medium:
        return "secondary";
      case LevelDifficulties.hard:
        return "primary";
      default:
        return "primary";
    }
  };

  return (
    <AppButton
      color={getColor()}
      variant="contained"
      startIcon={<SvgIcon fontSize="large" component={renderIcon()} />}
      onClick={onClick}
      sx={() => ({
        width: "100%",
        maxWidth: {
          xs: 350,
          md: 400,
        },
        textAlign: "left",
        justifyContent: "flex-start",
        minHeight: "64px !important",
        paddingLeft: "30px",
      })}
      {...props}
    >
      <Stack
        justifyContent="space-between"
        sx={{ alignSelf: "stretch", padding: "8px 2px" }}
      >
        <Typography
          sx={{
            textTransform: "uppercase",
            fontSize: {
              xs: isTooNarrow ? 14 : 16,
              md: 18,
            },
            fontWeight: "bold",
          }}
        >
          {name}
        </Typography>
        <Typography
          sx={{
            fontSize: {
              xs: isTooNarrow ? 13 : 14,
              md: 16,
            },
          }}
        >
          {renderSubTitle()}
        </Typography>
      </Stack>
    </AppButton>
  );
});
